import React, { Component } from 'react'
import './styles.scss';

export default class GEUsersHeader extends Component {
  render() {
    const { facilityName, parentFacityName, street, city, state, postalCode, country} = this.props.facilityDetails;
    return (
      <div className="ge-user-list-header-wrapper">
        <h1 className="customer-name__heading">{facilityName}</h1>
        {!!street ? <><div className="customer-address"><p>{street}</p></div>
        <div className="customer-address"><p>{`${city}, ${state}, ${postalCode} ${country}`}</p></div></> : <div className="customer-address"><p>-</p></div>}
        {this.props.activePage === "customerUsers" && <div className="customer-parent-name">{parentFacityName}</div>}
      </div>
    )
  }
}
